import React from 'react';

import Link from '@atlaskit/link';

import { CONTENT_HISTORY } from '@confluence/named-routes/entry-points/routes.ts';

export const getPageHistoryLink = (attributes) => {
	const { spaceKey, contentId, contentSlug } = attributes;
	return (...chunks) => (
		<Link
			target="_blank"
			href={CONTENT_HISTORY.toUrl({
				spaceKey,
				contentId,
				contentSlug,
			})}
		>
			{chunks}
		</Link>
	);
};
